<template>
  <f7-row class="wd-100">
    <f7-col width="50">
      <div
        class="w-170 h-135"
        :style="`background-image: url('//madai.mx/assets/images/${itm.image}'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
    </f7-col>
    <f7-col width="50">
      <span class="shopping-icon float-right">
        <f7-link @click="agregarCarrito(itm)">
          <f7-icon class="add_shopping_cart" :md="storage.carrito.find(item => item.cve === itm.cve) ? 'material:remove_shopping_cart' : 'material:add_shopping_cart'"></f7-icon>
        </f7-link>
      </span>
      <span class="d-block text-uppercase bold text-dark m-t-5">{{ itm.cve }}</span>
      <span class="favorite-icon">
        <f7-link
          @click="storage.wishlist.find(item => item.cve === itm.cve) === undefined ?
            storage.wishlist.push(itm) :
            storage.wishlist = storage.wishlist.filter(item => item.cve !== itm.cve)"
          >
          <f7-icon class="favorite-color" :md="storage.wishlist.find(item => item.cve === itm.cve) ? 'material:favorite' : 'material:favorite_border'"></f7-icon>
        </f7-link>
      </span>
      <span class="d-block text-uppercase fs-10 bold">{{ itm.type }}</span>
      <span class="d-block fs-13 m-t-8">
        {{
        $helper.str.capitalizar(itm.description) + ' ' +
        $helper.str.capitalizar(itm.materials) + ' ' +
        $helper.str.capitalizar(itm.color) +
        (itm.size ? `, Medida ${itm.size}` : '')
        }}
      </span>

      <div class="m-t-15">
        <span class="bold text-color-madai m-r-10">{{ $helper.str.formatearMoneda(itm.price) }}</span>
        <span class="fs-10 p-t-20">IVA INCLUIDO</span>
      </div>
      <span class="carrito-icon" :class="{ hide: !storage.carrito.find(item => item.cve === itm.cve) }">
        <f7-icon md="material:shopping_basket"></f7-icon>
      </span>
    </f7-col>
  </f7-row>
</template>

<script>
export default {
  props: ['itm'],
  methods: {
    agregarCarrito (itm) {
      if (this.storage.carrito.find(item => item.cve === itm.cve)) {
        this.storage.carrito = this.storage.carrito.filter(item => item.cve !== itm.cve)
      } else {
        this.storage.carrito.push(itm)
      }
    }
  }
}
</script>
